import React, { useContext } from "react";
import { AppContext } from "../../../App";
import CloseRegWithDetails from "./CloseRegWithDetails";
import MinimalCloseReg from "./MinimalCloseReg";

const CloseReg = ({ setShowForm }) => {
  const { settings } = useContext(AppContext);

  return (
    <>
      {settings.store?.closeRegWith === 1 ? (
        <MinimalCloseReg {...{ setShowForm }} />
      ) : (
        <CloseRegWithDetails {...{ setShowForm }} />
      )}
    </>
  );
};

export default CloseReg;
